import PropTypes from 'prop-types';
import React from 'react';
import { AutoSizer, Column, Table } from 'react-virtualized';
import modeConfig from '../pages/crosschannel/config/modeConfig';
import { displayAsMoney } from '../util/helpers/Numbers';
import { ScenarioModePropTypes } from '../util/helpers/SharedPropTypes';

function parseBudgetConstraintPercent(budgetConstraint) {
  if (budgetConstraint) {
    return `${Math.round(budgetConstraint.percent * 100)}%`;
  }
  return null;
}

function parseBudgetConstraintType(budgetConstraint) {
  if (budgetConstraint) {
    return budgetConstraint.type
                           .replace(/(^| )(\w)/g, s => s.toUpperCase());
  }
  return null;
}

const headerOverrides = {
  letterSpacing: '1px',
  background: '#eaf4fb',
};

const ScenarioViewModeData = ({ modes }) => (
  <div className='scenario-parameters-detail'>
    <h4>Scenario Parameters</h4>
    <div className='scenario-table'>
      <AutoSizer disableHeight>
        {({ width }) => (
          <Table
            width={width}
            height={50 + (modes.length * 50)}
            rowGetter={({ index }) => modes[index]}
            rowCount={modes.length}
            rowHeight={50}
            headerHeight={50}
            headerStyle={headerOverrides}
            className='scenario-mode-table'
          >
            <Column
              label='Mode name'
              minWidth={150}
              flexShrink={0}
              dataKey='key'
              cellDataGetter={
                ({ rowData }) => modeConfig[rowData.key].displayLabel
              }
            />
            <Column
              label='Cost (CPP)'
              minWidth={125}
              flexShrink={0}
              dataKey='cost'
              cellRenderer={
                ({ cellData }) => displayAsMoney(cellData)
              }
            />
            <Column
              label='Frequency cap'
              minWidth={125}
              flexShrink={0}
              dataKey='frequencyCap'
            />
            <Column
              label='Percent of buy type'
              minWidth={200}
              flexShrink={0}
              dataKey='budgetConstraint'
              cellDataGetter={
                ({ rowData }) => parseBudgetConstraintType(rowData.budgetConstraint)
              }
            />
            <Column
              label='Percent of buy cap'
              flexShrink={0}
              dataKey='percentage'
              cellDataGetter={
                ({ rowData }) => parseBudgetConstraintPercent(rowData.budgetConstraint)
              }
            />
          </Table>
        )}
      </AutoSizer>
    </div>
  </div>
);

ScenarioViewModeData.propTypes = {
  modes: PropTypes.arrayOf(ScenarioModePropTypes),
};

export default ScenarioViewModeData;
